var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('v-img', {
    staticClass: "campaign-view campaign-view--mobile",
    attrs: {
      "src": "/images/sub/campaign/one-meal/mobile.jpg"
    }
  }, [_vm._l(_vm.buttonList, function (btn, index) {
    return [_c('a', {
      key: index,
      staticClass: "campaign-view__button",
      class: `campaign-view__button--${btn}`,
      attrs: {
        "href": _vm.buttonlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.buttonText))])];
  })], 2), _c('v-img', {
    staticClass: "campaign-view campaign-view--pc",
    attrs: {
      "src": "/images/sub/campaign/one-meal/image.jpg"
    }
  }, [_vm._l(_vm.buttonList, function (btn, index) {
    return [_c('a', {
      key: index,
      staticClass: "campaign-view__button",
      class: `campaign-view__button--${btn}`,
      attrs: {
        "href": _vm.buttonlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.buttonText))])];
  })], 2), _c('div', {
    staticClass: "mt-40 mt-lg-60"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "justify": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "to": "/news/campaign",
      "outlined": "",
      "color": "grey-9"
    }
  }, [_vm._v("목록보기")])], 1)], 1)], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }